module.exports = __webpack_public_path__ + "img/Footer_9226.1ea57c4f.jpg";